import { render } from "./ProductStartersetSkeleton.vue?vue&type=template&id=2e72ab5e"
import script from "./ProductStartersetSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductStartersetSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__